// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".localized-text[data-v-6d4149ba]{white-space:pre-wrap}.optional-assembly-image[data-v-6d4149ba]{width:60px;height:60px}.assembly-image[data-v-6d4149ba]{margin-right:30px}.list li.non-optional-item .button-col .wikaButtonConf[data-v-6d4149ba]{pointer-events:none!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
